import { CommonModule, CurrencyPipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import {
  PvAuthenticationModule,
  PvTokenExpiredModule,
} from '@pv-frontend/authentication';
import {
  ErrorService,
  GvRedemptionModule,
} from '@pv-frontend/gift-voucher-journey';
import { PVHeaderModule } from '@pv-frontend/header';
import { JOURNEY_METADATA_SERVICE_TOKEN } from '@pv-frontend/pv-shared-services/journey-metadata-service';
import { PV_USER_SERVICE } from '@pv-frontend/pv-shared-services/pv-user-service';
import { TelemetryModule } from '@pv-frontend/pv-shared-services/telemetry-service';
import * as Sentry from '@sentry/angular';
import { ToastrModule } from 'ngx-toastr';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { environment } from '../environments/environment';
import { ErrorInterceptor } from '../interceptors/error.interceptor';
import { TokenInterceptor } from '../interceptors/token.interceptor';
import { JourneyMetaDataServiceImpl } from '../journey-metadata-impl.service';
import { PvUserServiceImpl } from '../user-service-impl.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { appConstants } from './app.constants';
import { FooterModule } from './footer/footer.module';
import { GVMSRedemptionComponent } from './gvms-redemption/gvms-redemption.component';
import { HomeModule } from './home/home.module';
import { InfoModule } from './info/info.module';
import { LumberjackTelemetryProvider } from './telemetry-providers/lumberjack-telemetry-provider';

@NgModule({
  declarations: [AppComponent, GVMSRedemptionComponent],
  imports: [
    BrowserModule,
    CommonModule,
    GvRedemptionModule,
    AppRoutingModule,
    PvAuthenticationModule,
    BrowserAnimationsModule,
    ToastModule,
    HomeModule,
    ToastrModule.forRoot(),
    PVHeaderModule,
    TelemetryModule.forRoot([
      {
        telemetryProvider: LumberjackTelemetryProvider,
        initConfig: {
          writeKey: 'writeKey',
          projectId: 'projectId',
        },
        enableErrorTracking: false,
        enableEventTracking: true,
        enablePageTracking: true,
      },
    ]),
    PvTokenExpiredModule,
    FooterModule,
    InfoModule,
  ],
  providers: [
    {
      provide: JOURNEY_METADATA_SERVICE_TOKEN,
      useExisting: JourneyMetaDataServiceImpl,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: PV_USER_SERVICE,
      useExisting: PvUserServiceImpl,
    },
    {
      provide: 'gtmLabels',
      useValue: appConstants.trackLabels,
    },
    {
      provide: 'environment',
      useValue: environment,
    },
    {
      provide: 'env',
      useValue: environment,
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    PvUserServiceImpl,
    JourneyMetaDataServiceImpl,
    MessageService,
    ErrorService,
    LumberjackTelemetryProvider,
    CurrencyPipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
